module.exports = __webpack_public_path__ + "img/9788982739958.cefcc50e.jpg";